import { ESTIMATION_ISSUE_COUNT } from '@atlassian/jira-software-report-charting-common/src/common/utils/format-estimate/index.tsx';
import type { Action } from '@atlassian/react-sweet-state';
import type {
	State,
	SprintReportsEstimationStatistic,
	Sprint,
	SprintReportsFilters,
} from '../../common/types';

/**
 * Set the sprint id option and update the query variables
 */
export const setSprintAndDirty =
	(newValue: Sprint): Action<State> =>
	({ getState, setState }) => {
		const { dataVariables } = getState();

		setState({
			sprint: newValue,
			dataVariables: {
				...dataVariables,
				sprintId: newValue.id,
			},
		});
	};

/**
 * Set the estimation field option and update the query variables
 */
export const setEstimationFieldAndDirty =
	(newValue: SprintReportsEstimationStatistic): Action<State> =>
	({ getState, setState }) => {
		const { dataVariables } = getState();

		setState({
			estimation: newValue,
			dataVariables: {
				...dataVariables,
				estimation: newValue,
			},
		});
	};

export const setDataLoadedOnce =
	(newValue: boolean): Action<State> =>
	({ setState }) => {
		setState({
			dataLoadedOnce: newValue,
		});
	};

/**
 * Select default fields when the data is loaded with default values.
 */
export const selectFiltersOnDataLoaded =
	(
		filters: null | SprintReportsFilters,
		estimationType: SprintReportsEstimationStatistic = ESTIMATION_ISSUE_COUNT,
		retroPublishedSprintId: string | null = null,
	): Action<State> =>
	({ getState, setState }) => {
		if (!filters) {
			return;
		}

		const { sprint, estimation } = getState();
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const stateUpdate: Record<string, any> = {};

		// Select the sprint of the newly published retro
		if (retroPublishedSprintId) {
			const newSprint = filters.sprints.find((val) => val.id.toString() === retroPublishedSprintId);
			if (newSprint) {
				stateUpdate.sprint = newSprint;
			}
		}

		if (!stateUpdate.sprint && !sprint && filters.sprints[0]) {
			const newSprint: Sprint = filters.sprints[0];
			stateUpdate.sprint = newSprint;
		}

		if (!estimation) {
			stateUpdate.estimation = estimationType;
		}

		setState(stateUpdate);
	};
